import React from 'react';
import { Form } from 'antd';
import { connect } from 'react-redux';

class HiBodyTutorial extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            result: [],
        };
    }

    render() {
        return (
        <Form
            layout='vertical'
            hideRequiredMark
            style={{ margin: 20 }}
        >
            <h3 style={{ color: '#13171F' }}>操作說明</h3>
            <div style={{ 
                borderColor: '#13171F', 
                borderWidth: 1, 
                borderRadius: 8, 
                borderStyle: 'solid' }}
            >
                <div style={{ padding: 8 }}>
                    <h4 style={{ color: '#13171F' }}>※ 小提醒</h4>
                    <p style={{ fontSize: 13 }}>進行影音輕鬆動之前，您會需要：<br/>- 穩定的網路環境：避免播放卡頓及動作錄製中斷<br/>- 可上網的螢幕裝置：建議使用桌電或筆電上的 Google Chrome 來播放運動影音</p>
                </div>
            </div>
            <p style={{ fontSize: 13, marginTop: 12 }}>上述的準備完成後，您可依照下列方式開始進行影音輕鬆動：</p>
            <Form.Item label='方式一'>
                <p>1. 建議使用桌電或筆電的 Google Chrome 來開啟運動影音網頁（http://hibody.app)<br/>2. 在網頁上選擇您想進行的運動影音<br/>3. 仔細閱讀注意事項後點選「準備好了」<br/>4. 點選「掃碼挑戰」，掃描螢幕上的 QRcode<br/>5. 等待倒數完成，即可開始進行挑戰</p>
            </Form.Item>
            <Form.Item label='方式二'>
                <p>1. 選擇要挑戰的項目<br/>2. 點選頁面下方「開始挑戰」<br/>3. 點選「分享連結」，將影片連結傳送至可連結網路的螢幕裝置<br/>4. 建議使用桌電或筆電上的 Google Chrome 開啟連結，仔細閱讀完注意事項後，點選「準備好了」<br/>5. 點選「掃描條碼」，掃描螢幕上的 QRcode<br/>6. 等待倒數完成，即可開始進行挑戰</p>
            </Form.Item>
            <div style={{ marginTop: 44 }}>
                <h3 style={{ color: '#13171F' }}>HiBody輕鬆動</h3>
                <p style={{ marginTop: 12 }}>Hibody 輕鬆動能跟著教練一起動，拿著手機就能為你紀錄運動軌跡，並進行評分，也可以將影片在其他裝置上開啟，與親朋好友掃描 QRcode 同時進行挑戰！<br/>影音評分後的分數，可以作為運動紀錄上傳，開始挑戰看看吧！</p>
            </div>
        </Form>);
    }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HiBodyTutorial);